import { type ChangeEvent, type FC } from 'react';

import {
  Pagination,
  PaginationBar,
  PaginationBarLeft,
  PaginationBarRight,
  SelectField,
} from '@wk/components-react16';

import { SITE_COMPLIANCE_PAGE_SIZE_OPTIONS } from '@/domains/siteCompliance';

interface SiteCompliancePaginationProps {
  isMobileViewport: boolean;
  totalCount: number;
  page: number;
  pageCount: number;
  limit: number;
  onLimitChange: (limit: number) => void;
  onPageChange: (page: number) => void;
}

const SiteCompliancePagination: FC<SiteCompliancePaginationProps> = ({
  isMobileViewport,
  totalCount,
  page,
  pageCount,
  limit,
  onLimitChange,
  onPageChange,
}) => {
  if (isMobileViewport) {
    return (
      <div className="site-compliance-pagination-mobile-row">
        <span className="site-compliance-pagination-mobile-results">
          {totalCount} sites
        </span>
        <span className="site-compliance-pagination-mobile-page">
          {page}/{pageCount || 1}
        </span>
        <div className="site-compliance-pagination-mobile-limit">
          <SelectField size="small">
            <select
              value={limit}
              onChange={(event: ChangeEvent<HTMLSelectElement>) => {
                onLimitChange(Number(event.target.value));
              }}
            >
              {SITE_COMPLIANCE_PAGE_SIZE_OPTIONS.map((pageSizeOption) => (
                <option key={pageSizeOption} value={pageSizeOption}>
                  {pageSizeOption}
                </option>
              ))}
            </select>
          </SelectField>
        </div>
        <Pagination
          pageIndex={page}
          pageCount={pageCount}
          onUserRequest={onPageChange}
        />
      </div>
    );
  }

  return (
    <PaginationBar>
      <PaginationBarLeft>{totalCount} sites </PaginationBarLeft>
      <PaginationBarRight>
        <div className="flex items-center gap-4">
          <p className="text-sm text-muted-foreground">
            Page {page} of {pageCount}
          </p>
          <SelectField size="small">
            <select
              value={limit}
              onChange={(event: ChangeEvent<HTMLSelectElement>) => {
                onLimitChange(Number(event.target.value));
              }}
            >
              {SITE_COMPLIANCE_PAGE_SIZE_OPTIONS.map((pageSizeOption) => (
                <option key={pageSizeOption} value={pageSizeOption}>
                  {pageSizeOption}
                </option>
              ))}
            </select>
          </SelectField>
          <Pagination
            pageIndex={page}
            pageCount={pageCount}
            onUserRequest={onPageChange}
          />
        </div>
      </PaginationBarRight>
    </PaginationBar>
  );
};

export default SiteCompliancePagination;
